// Praia Sunset — beach bars, seafood restaurants, sunset views
// Warm golden sand + coral/orange sunset, very rounded
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#fff8f0', dark: '#180800' },
    card:            { light: '#fde8cc', dark: '#2a1200' },
    surface:         { light: '#f5d4a8', dark: '#3d1c00' },
    action:          { light: '#c2410c', dark: '#fb923c' },
    actionHover:     { light: '#9a3412', dark: '#fdba74' },
    textPrimary:     { light: '#1c0a00', dark: '#fff3e8' },
    textSecondary:   { light: '#4a1a00', dark: '#fcd5ac' },
    textMuted:       { light: '#8a4020', dark: '#d4906a' },
    textMutedSubtle: { light: '#b06040', dark: '#a06040' },
    border:          { light: '#e0a870', dark: '#5a2800' },
    borderSubtle:    { light: '#f0c898', dark: '#401a00' },
    link:            { light: '#c2410c', dark: '#fb923c' },
    linkBg:          { light: '#fff7ed', dark: 'rgba(194,65,12,0.18)' },
    linkBorder:      { light: '#fed7aa', dark: '#7c2d12' },
    linkHover:       { light: '#ffedd5', dark: 'rgba(194,65,12,0.3)' },
    inputBg:         { light: '#fffcf8', dark: '#2a1200' },
    inputBorder:     { light: '#e0a870', dark: '#5a2800' },
    inputText:       { light: '#1c0a00', dark: '#fff3e8' },
    focusRing:       { light: '#c2410c', dark: '#fb923c' },
    overlay:         { light: 'rgba(28,10,0,0.5)', dark: 'rgba(0,0,0,0.8)' },
    confirm:         { light: '#b06040', dark: '#5a2800' },
    confirmHover:    { light: '#8a4020', dark: '#6a3500' },
    confirmText:     { light: '#ffffff', dark: '#fff3e8' },
    confirmBg:       { light: '#fff8f0', dark: '#2a1200' },
    confirmBorder:   { light: '#f0c898', dark: '#5a2800' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#9b1c1c', dark: '#f87171' },
    errorHover:      { light: '#7f1d1d', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#0369a1', dark: '#38bdf8' },
    infoHover:       { light: '#075985', dark: '#0ea5e9' },
    infoBg:          { light: '#f0f9ff', dark: 'rgba(3,105,161,0.25)' },
    infoText:        { light: '#0ea5e9', dark: '#7dd3fc' },
    infoBorder:      { light: '#bae6fd', dark: '#075985' },
  },
  borderRadius: {
    card:      '36px',
    container: '22px',
    page:      '30px',
    button:    '9999px',
    input:     '16px',
    badge:     '10px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '6px',
    device:  '8px',
  },
  textures: {
    main:    { light: '/textures/sandTexture.jpg', dark: '/textures/sandTexture.jpg', size: '900px 900px', blendLight: 'multiply', blendDark: 'overlay', opacityLight: 0.10, opacityDark: 0.15 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
